import { Component, Input, OnInit } from '@angular/core';
import { CommonService } from 'src/app-core/services/common.service';

@Component({
  selector: 'app-orders-rfq-details',
  templateUrl: './orders-rfq-details.component.html',
  styleUrls: ['./orders-rfq-details.component.scss']
})
export class OrdersRfqDetailsComponent implements OnInit {

  @Input() set rfqData(rfqData: any) {
    if (rfqData) {
      this.rfqDetails = rfqData;
      if (this.rfqDetails.phone) {
        this.rfqDetails.phone = this.commonService.getFormattedPhoneNumber(this.rfqDetails.phone);
      }
    }
  }

  rfqDetails: any;

  constructor(private commonService: CommonService) {
  }

  ngOnInit() {
  }

}
